/**
 * PRICE OVERRIDES FOR LOCAL TESTING
 * This file allows you to override menu item prices locally for testing
 * without needing to update Firebase
 */

// Price overrides - FINAL prices (including VAT)
// Format: { "Item Name": price }
export const PRICE_OVERRIDES: Record<string, number> = {
  // Crispy Rolls - Priority fixes
  'Chicken-Crispy Roll': 10.90,
  'Chicken–Crispy Roll': 10.90,
  'Big Salmon-Crispy Roll': 11.90,
  'Big Salmon–Crispy Roll': 11.90,
  'Ebi-Crispy Roll': 10.90,
  'Ebi–Crispy Roll': 10.90,
  'Veggie-Crispy Roll': 9.90,
  'Veggie–Crispy Roll': 9.90,
  'Fitness-Crispy Roll': 10.90,
  'Fitness–Crispy Roll': 10.90,
  'Tuna-Crispy Roll': 9.90,
  'Tuna–Crispy Roll': 9.90,
  
  // Add more overrides as needed
};

/**
 * Normalize item name for matching
 */
function normalizeName(name: string): string {
  return name.toLowerCase()
    .replace(/[^\w\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Check if an item has a price override
 */
export function getPriceOverride(itemName: string): number | null {
  const normalized = normalizeName(itemName);
  
  // Try exact match first
  for (const [key, price] of Object.entries(PRICE_OVERRIDES)) {
    if (normalizeName(key) === normalized) {
      return price;
    }
  }
  
  // Try partial match
  for (const [key, price] of Object.entries(PRICE_OVERRIDES)) {
    const keyNormalized = normalizeName(key);
    if (normalized.includes(keyNormalized) || keyNormalized.includes(normalized)) {
      return price;
    }
  }
  
  return null;
}

/**
 * Apply price override to menu item
 */
export function applyPriceOverride(item: any): any {
  const override = getPriceOverride(item.name || item.name_de || '');
  
  if (override) {
    // Check if item is a drink
    const categoryName = (item.category || item.category_name || '').toLowerCase();
    const isDrink = categoryName.includes('drink') || 
                    categoryName.includes('getränk') || 
                    categoryName.includes('beverage') ||
                    categoryName.includes('getränke');
    
    // Calculate base price from price_with_tax
    // Use 19% as default (dine-in), actual tax calculated at checkout
    const basePrice = Math.round((override / 1.19) * 100) / 100;
    const taxRate = isDrink ? 19 : 19;
    
    const oldPrice = item.price_with_tax || item.base_price || 0;
    if (Math.abs(oldPrice - override) > 0.01) {
      console.log(`💰 [PRICE OVERRIDE] ${item.name}: €${oldPrice} → €${override} (base: €${basePrice.toFixed(2)})`);
    }
    
    return {
      ...item,
      price_with_tax: override,
      base_price: basePrice,
      tax_rate: taxRate,
    };
  }
  
  return item;
}

